import type { BuildupPhase } from './resolveInitialPhase'

const KEY_PREFIX = 'lc.buildup.phase.'

function keyFor(progressId: number | null): string | null {
  if (progressId == null) return null
  return `${KEY_PREFIX}${progressId}`
}

export function readBuildupPhase(progressId: number | null): string | null {
  const k = keyFor(progressId)
  if (!k) return null
  try {
    return sessionStorage.getItem(k)
  } catch {
    return null
  }
}

export function writeBuildupPhase(
  progressId: number | null,
  phase: BuildupPhase,
): void {
  const k = keyFor(progressId)
  if (!k) return
  try {
    sessionStorage.setItem(k, phase)
  } catch {
    // ignore quota / availability errors
  }
}

export function clearBuildupPhase(progressId: number | null): void {
  const k = keyFor(progressId)
  if (!k) return
  try {
    sessionStorage.removeItem(k)
  } catch {
    // ignore
  }
}
